import React from 'react';
import { Line } from 'react-chartjs-2';
import 'chart.js/auto';

const TrendDeviceChart = ({ details, batches }) => {
    if (!details || !batches || Object.keys(details).length === 0) {
        return null;
    }

    const statusMap = { 'Normal': 0, 'Unknown': 1, 'Spam': 2, 'No Data': null };
    const statusLabels = ['Normal', 'Unknown', 'Spam'];

    const labels = Object.values(batches);
    const batchKeys = Object.keys(batches);

    const datasets = Object.keys(details).map(tn_number => {
        const dataPoints = batchKeys.map(batchKey => statusMap[details[tn_number][batchKey]]);
        const randomColor = `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 1)`;
        return {
            label: tn_number,
            data: dataPoints,
            borderColor: randomColor,
            backgroundColor: randomColor,
            fill: false,
            spanGaps: true, // To connect points with null data in between
        };
    });

    const chartData = {
        labels: labels,
        datasets: datasets,
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Number Status Trend Across Batches',
                font: {
                    size: 16,
                },
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = context.dataset.label || '';
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            label += statusLabels[context.parsed.y];
                        }
                        return label;
                    },
                },
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Batch',
                },
            },
            y: {
                title: {
                    display: true,
                    text: 'Status',
                },
                min: 0,
                max: 2,
                ticks: {
                    stepSize: 1,
                    callback: function (value, index, ticks) {
                        return statusLabels[value];
                    },
                },
            },
        },
    };

    return (
        <div className="common-white-shadow-background setting-section" style={{ marginTop: '20px' }}>
            <div style={{ height: '400px', width: '100%' }}>
                <Line data={chartData} options={options} />
            </div>
        </div>
    );
};

export default TrendDeviceChart;

